import React from "react";

import Navbar from "./navBar";
import "./styles/service.css";

function Services() {
  return (
    <div>
      <Navbar />
      {/* <!-- ======= Services Section ======= --> */}
      <section id="services" className="services">
        <div className="container">
          <div className="section-title">
            <h2>Skills</h2>
            <p>My Skills</p>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
              <div className="icon-box">
                <div className="icon">
                  <i className="bx bxl-dribbble"></i>
                </div>
                <h4>
                  <a href="/">Frontend Web Development</a>
                </h4>
                <p>
                  Building scalable, beautiful, data-driven web applications
                  with HTML, CSS, Javascript, React.
                </p>
              </div>
            </div>

            {/* < <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
              <div className="icon-box">
                <div className="icon">
                  <i className="bx bx-file"></i>
                </div>
                <h4>
                  <a href="/">Mobile App Development</a>
                </h4>
                <p>
                  Building Mobile based, cross platform applications
                </p>
              </div>
            </div>> */}

            <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0">
              <div className="icon-box">
                <div className="icon">
                  <i className="bx bx-tachometer"></i>
                </div>
                <h4>
                  <a href="/">UI/UX Design</a>
                </h4>
                <p>
                  Implementing design thinking to create engaging user
                  interface.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4">
              <div className="icon-box">
                <div className="icon">
                  <i className="bx bx-world"></i>
                </div>
                <h4>
                  <a href="/">Training</a>
                </h4>
                <p>
                  Impacting sustainable skills to the upcoming via virtual and
                  online class. Also mentoring students one in one.
                </p>
              </div>
            </div>

            {/* <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4">
              <div className="icon-box">
                <div className="icon">
                  <i className="bx bx-slideshow"></i>
                </div>
                <h4>
                  <a href="/">SEO Management</a>
                </h4>
                <p>
                  Quis consequatur saepe eligendi voluptatem consequatur dolor
                  consequuntur
                </p>
              </div>
            </div> */}

            <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4">
              <div className="icon-box">
                <div className="icon">
                  <i className="bx bx-arch"></i>
                </div>
                <h4>
                  <a href="/">Technical Writing</a>
                </h4>
                <p>Transferring knowledge through writing Technical articles</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Services Section --> */}
    </div>
  );
}

export default Services;
